import axios from "axios";
import { apicall } from "../../services/api";
import { GET_OFFERINGS, GET_EXPIRING_OFFERS, ERR_OFFERING, LOADING_OFFERINGS } from "../actions/actionTypes";
import { baseURL } from "./voucher.actions";
import axiosInstance from "../../utils/axiosInterceptor";
import { toast } from "react-hot-toast";

export const getAllOfferings = (status) => async (dispatch, getState) => {
	if (status) {
		dispatch({
			type: LOADING_OFFERINGS,
			payload: true,
		});
	}

	if (getState()?.offeringReducer?.offerings?.length > 0) return

	try {
		const res = await apicall(`offerings`, "get");
		if (res.data.msg === "No data found.") {
			dispatch({
				type: GET_OFFERINGS,
				payload: res.data.data,
			});
		} else {
			dispatch({
				type: GET_OFFERINGS,
				payload: res.data.data,
			});
		}
	} catch (err) {
		dispatch({
			type: ERR_OFFERING,
			payload: { msg: err.response?.msg, status: err.response.status },
		});
	}
};


export const getAllOfferingsV3 = (page = 1, limit = 10, search = '' ,status = false) => async (dispatch, getState) => {
	
	try {
		if (status) {
			dispatch({
				type: LOADING_OFFERINGS,
				payload: true,
			});
		}
	

		// Build query string
		const query = new URLSearchParams({
			page,
			limit,
			...(search && { search: search}),
		}).toString();
		// console.log(query,"query")

		const res = await apicall(`offerings?${query}`, 'get', null, {}, 'v3');
		

		dispatch({
			type: GET_OFFERINGS,
			payload: res.data?.data || [],
		});
	} catch (err) {
		dispatch({
			type: ERR_OFFERING,
			payload: {
				msg: err.response?.data?.msg || 'Failed to fetch offerings',
				status: err.response?.status || 500,
			},
		});
	}
};

export const getExpiringOffers = () => async (dispatch, getState) => {
	dispatch({
		type: LOADING_OFFERINGS,
		payload: true,
	});

	try {
		const res = await apicall('offerings/expired-offerings', 'get', null, {}, 'v3');
		if (res.status === 200) {
			dispatch({
				type: GET_EXPIRING_OFFERS,
				payload: res.data.data
			});
		}
	} catch (err) {
		dispatch({
			type: ERR_OFFERING,
			payload: { msg: err.response, status: err.response.status },
		});
	}

}

export const updateOffering = (offering_id, formData) => async (dispatch) => {
	try {
		const path = `offerings/${offering_id}`
		const res = await apicall(path, 'patch', formData, {}, 'v3');
		dispatch({
			type: ERR_OFFERING,
			payload: { msg: "Offer update successfully!", status: res.status },
		});

		toast.success("Offer update successfully!");
		dispatch(getAllOfferingsV3(1, 10, '', true));
	} catch (err) {
		dispatch({
			type: ERR_OFFERING,
			payload: { msg: err.message, status: err.response.status },
		});
		dispatch(showLoading(false));
		toast.error(err.message || "Something went wrong while updating offer");
	}
};

export const showLoading = (flag) => async (dispatch) => {
	dispatch({
		type: LOADING_OFFERINGS,
		payload: flag,
	});
}